angular.module('dnecom')
    .controller('CartsSettingsController', ["$scope", "$http", "notifications", "$location", "ErrorBag", function ($scope, $http, notifications, $location, ErrorBag) {
        $scope.store = TemplateData.value('store');
        $scope.properties = TemplateData.value('properties');

        if (!$scope.properties) {
            $scope.properties = {};
        }

        if (!$scope.properties.carts) {
            $scope.properties.carts = {};
        }

        $scope.properties.carts.enableTimer = parseInt($scope.properties.carts.enableTimer);
        $scope.properties.carts.enableMobileTimer = parseInt($scope.properties.carts.enableMobileTimer);
        $scope.properties.carts.timerHours = parseInt($scope.properties.carts.timerHours);
        $scope.properties.carts.timerMinutes = parseInt($scope.properties.carts.timerMinutes);
        $scope.properties.carts.isNotOptionalNumber = parseInt($scope.properties.carts.isNotOptionalNumber);

        var originalSettings = angular.copy($scope.properties.carts);

        $scope.currentTab = $location.search().tab || 'General';
        $scope.saving = false;

        $scope.changeTab = function(tab) {
            if (!angular.equals($scope.properties.carts, originalSettings)) {
                if (!confirm('Save changes? Otherwise it will be lost.')) {
                    cancelSave();
                    return;
                }

                saveSettings(tab);
            }

            $scope.currentTab = tab;
        };

        $scope.toggleProperty = function(key) {
            $scope.properties.carts[key] = $scope.properties.carts[key] ? 0 : 1;
        };

        $scope.isPropertyEnabled = function(key) {
            return !!$scope.properties.carts[key];
        };

        $scope.save = function () {
            return saveSettings();
        };

        $scope.reset = function () {
            cancelSave();
            notifications.info('Carts settings reset completed.');
        };

        $scope.areSettingsChanged = function () {
            return !angular.equals($scope.properties.carts, originalSettings);
        };

        var saveSettings = function (tab) {
            if (!validate()) {
                return false;
            }

            $scope.saving = true;

            $http
                .put(
                    Routing.generate('stores_update_settings', { id: $scope.store.id, group: 'Carts' + $scope.currentTab }),
                    {
                        properties: $scope.properties
                    }
                )
                .then(function (response) {
                    if (!response.data.success) {
                        notifications.danger(response.data.message);
                        return;
                    }

                    notifications.success('Carts settings saved.');

                    originalSettings = angular.copy($scope.properties.carts);

                    if (tab) {
                        $scope.currentTab = tab;
                    }
                }, function (response) {
                    notifications.danger('Request error.');
                })
                .finally(function() {
                    $scope.saving = false;
                })
            ;
        };

        var validate = function() {
            if (!$scope.properties.carts.enableTimer) {
                return true;
            }

            if ($scope.properties.carts.timerHours == 0 && $scope.properties.carts.timerMinutes < 45) {
                notifications.danger('Time cannot be shorter than 45 minutes.');
                return false;
            }

            if ($scope.properties.carts.timerHours == 8 && $scope.properties.carts.timerMinutes > 0) {
                notifications.danger('Time cannot be longer than 8 hours.');
                return false;
            }

            return true;
        };

        var cancelSave = function () {
            $scope.properties.carts = angular.copy(originalSettings);
        };
    }]);
